import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class BeneficialOwnerService {

  constructor( private httpService: HttpService) { }



  samplebeneficialOwnerRecord(object) {
      console.log("object", object);
      // return this.http.post(environment.pssUrl + 'Investment/poaEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
      //         .map(res => res.json());
      var request = {
          URL: "beneficial-owner/beneficialOwnerEntry",
          DATA: object
      }
      return this.httpService.post(request);


  }

  getRegisterDirector(object) {
      var registerList = {
          URL: "beneficial-owner/getbeneficialOwner/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);

  }

  removebeneficialOwnerdetails(_id) {
      var request = {
          URL: "beneficial-owner/deletebeneficialOwnerdetail/" + _id
      }
      return this.httpService.get(request);
  }

  updateBen(_id) {
      var editlist = {
          URL: "beneficial-owner/update/" + _id,
      }
      return this.httpService.post(editlist);
  }


  updatebeneficialOwner(object, id) {
      var request = {
          URL: "beneficial-owner/updatebeneficialOwner/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  generatebeneficialOwnerDocument(object) {
      var request = {
          URL: "beneficial-owner/generatebeneficialOwnerDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadbeneficialOwnerFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "beneficial-owner/downloadDocument/" + id + "/" + type + "/" + token;
  }

  downloadbeneficialOwnerPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "beneficial-owner/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}
